import { UseQueryResult } from '@tanstack/react-query';
import i18next from 'i18next';
import { httpServices } from './httpServices';
import { NOTIFICATION_GET_ADMISSIONS_PATIENT_DATA_ENDPOINT } from '../constants/notificationConstants';

const { get } = httpServices;

export interface IGetPatientDataHospitalAdmission {
  enabled?: boolean;
  HospitalId: string;
  PatientIdentification?: string | null;
  IdentificationType?: number | null;
  HospitalAdmissionId?: string | null;
}

export interface IGetPatientDataHospitalAdmissionResponse {
  medicalRecord: string;
  patientName: string;
  birthDate: string;
  genderCode: number;
  gender: string;
  age: number;
  unitAdmissionId: string;
  hospitalAdmissionId: string;
  institutionAdmissionOutPatientId: string;
}

const GetPatientDataHospitalAdmission = ({
  enabled,
  HospitalId,
  PatientIdentification,
  IdentificationType,
  HospitalAdmissionId,
}: IGetPatientDataHospitalAdmission): UseQueryResult<IGetPatientDataHospitalAdmissionResponse> => {
  const url =
    process.env.NEXT_PUBLIC_BASE_API_URL_ADMISSIONS +
    NOTIFICATION_GET_ADMISSIONS_PATIENT_DATA_ENDPOINT;

  return get({
    key: [
      'hospitalAdmissionData',
      'patient-data',
      HospitalId,
      PatientIdentification ?? '',
      IdentificationType ?? '',
      HospitalAdmissionId ?? '',
      i18next.language,
    ],
    url: url,
    params: {
      HospitalId,
      HospitalAdmissionId,
      PatientIdentification,
      IdentificationType,
      CultureCode: i18next.language,
    },
    enabled,
  }) as UseQueryResult<IGetPatientDataHospitalAdmissionResponse>;
};

export const admissionsServices = {
  GetPatientDataHospitalAdmission,
};
